import React, { Component } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MiniWidget from "../../../components/MiniWidget/index";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import DynamicFormToFilter from "../../../components/forms/DynamicFormToFilter";
import { Link } from "react-router-dom";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class NonCahortReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reports: null,
      clients: [],
      columns: [
        {
          Header: "Media Source",
          // accessor: "media_source",
          accessor: row => (
            <Link
              to={{
                pathname: `/non-cahort-report/`,
              }}
            >
              {row.media_source}
            </Link>
          ),
          isSorted: true,
        },
        {
          Header: "Clicks",
          accessor: "clicks",
          isSorted: true,
        },
        {
          Header: "Installs post click",
          accessor: "installs_post_click",
          isSorted: true,
        },
        {
          Header: " CPI post click + post view",
          accessor: "CPI_post_click_plus_post_view",
          isSorted: true,
        },
        {
          Header: "CPI post click",
          accessor: "CPI_post_click",
          isSorted: true,
        },
        {
          Header: "Installs post view",
          accessor: "installs_post_view",
          isSorted: true,
        },
        {
          Header: "Shows",
          accessor: "shows",
          isSorted: true,
        },
        {
          Header: "Spend",
          accessor: "spend",
          isSorted: true,
        },
        {
          Header: "Payment",
          accessor: "payment",
          isSorted: true,
        },
        {
          Header: "Profit",
          accessor: "profit",
          isSorted: true,
        },
        {
          Header: "CTR",
          accessor: "CTR",
        },
        {
          Header: "CPC",
          accessor: "CPC",
        },
        {
          Header: "CPM",
          accessor: "CPM",
        },
        {
          Header: "CR",
          accessor: "CR",
        },
      ],
    };
  }

  componentDidMount() {
    // if (app_id) {
    //   data.start_date = getSelectedMonthAgo(2);
    //   data.end_date = getCurrentDay();
    //   data.app_id = app_id;
    //   if (this.props.nonCahortDate === null) {
    //     this.props.setNonCahortReportDate(data);
    //     this.props.getQualityMediaSource(data);
    //     this.props.getQualityWidgets(data);
    //   } else {
    //     let cahortDate = this.props.nonCahortDate;
    //     let updateCahort = {};
    //     updateCahort.app_id = app_id;
    //     updateCahort.start_date = cahortDate.start_date;
    //     updateCahort.end_date = cahortDate.end_date;
    //     this.props.getQualityMediaSource(updateCahort);
    //     this.props.getQualityWidgets(updateCahort);
    //   }
    // }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (prevProps.quality_widgets !== this.props.quality_widgets) {
    //   const widgets = this.props.quality_widgets[0];
    //   this.setState({
    //     reports: [
    //       {
    //         icon: "mdi mdi-eye-check-outline",
    //         title: "Impressions",
    //         value: widgets?.shows_sum || 0,
    //         badgeValue:
    //           widgets?.shows_change > 0
    //             ? `+ ${widgets?.shows_change}%`
    //             : widgets?.shows_change !== undefined
    //             ? `- ${widgets?.shows_change}%`
    //             : `Undefined`,
    //         color: widgets?.shows_change > 0 ? "success" : "danger",
    //         desc: "From previous period",
    //       },
    //       {
    //         icon: "mdi mdi-cursor-default-click-outline",
    //         title: "Clicks",
    //         value: widgets?.clicks_sum || 0,
    //         badgeValue:
    //           widgets?.clicks_change > 0
    //             ? `+ ${widgets?.clicks_change}%`
    //             : widgets?.clicks_change !== undefined
    //             ? `- ${widgets?.clicks_change}%`
    //             : `Undefined`,
    //         color: widgets?.clicks_change > 0 ? "success" : "danger",
    //         desc: "From previous period",
    //       },
    //       {
    //         icon: "mdi mdi-contactless-payment-circle-outline",
    //         title: "Payment",
    //         value: this.props.quality_widgets[0]?.payment_sum || 0,
    //       },
    //       {
    //         icon: "mdi mdi-cash-100",
    //         title: "Spend",
    //         value: this.props.quality_widgets[0]?.spend_sum || 0,
    //       },
    //       {
    //         icon: "mdi mdi-cash-plus",
    //         title: "Profit",
    //         value: this.props.quality_widgets[0]?.profit_sum || 0,
    //       },
    //     ],
    //   });
    // }
  }

  onFiltersChange = (type, filter) => {
    // const data = this.props.nonCahortDate;
    // data.start_date = filter.start_date;
    // data.end_date = filter.end_date;
    // data.app_id = this.props.match.params.app_id;
    // this.props.getQualityMediaSource(data);
    // this.props.getQualityWidgets(data);
    // this.props.setNonCahortReportDate(data);
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="All Media Sources | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Non cahort quality report"
              breadcrumbItem={"Non cahort quality report"}
              link="/non-cahort-report"
            />

            <DynamicFormToFilter
              onFiltersChange={this.onFiltersChange}
              filtersFields={[]}
              //selectedDate={this.props.nonCahortDate}
            />

            {this.state.reports !== null && (
              <Col xl={12}>
                <Row>
                  <MiniWidget data={this.state.reports} />
                </Row>
              </Col>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <Row className="justify-content-between align-middle">
                      <Col xs={6}>
                        <h5 className="mb-2">All media sources</h5>
                      </Col>
                    </Row>
                    <ReactTableForm
                      //loading={this.props.loading}
                      columns={this.state.columns}
                      data={[]}
                      onTableChange={this.onTableChange}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

NonCahortReport.propTypes = {};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(NonCahortReport);
